import React, { useCallback, useState } from 'react';

// ============================================================
// Selector BCV/USD único de los reportes (#115). Mismo control, mismo
// texto y mismo valor inicial en todas las pantallas, y recuerda la última
// elección del usuario en este navegador (si el navegador no deja guardar,
// arranca en BCV y listo).
//
//   const [vista, setVista] = useVistaMoneda();
//   <SelectorMoneda vista={vista} onChange={setVista} />
//
// `vista` es 'BCV' o 'USD'.
// ============================================================

const CLAVE = 'tgf.vistaMoneda';

function leer() {
  try {
    const v = window.localStorage.getItem(CLAVE);
    return v === 'USD' ? 'USD' : 'BCV';
  } catch {
    return 'BCV';
  }
}

export function useVistaMoneda() {
  const [vista, setVistaLocal] = useState(leer);
  const setVista = useCallback((v) => {
    const nueva = v === 'USD' ? 'USD' : 'BCV';
    setVistaLocal(nueva);
    try { window.localStorage.setItem(CLAVE, nueva); } catch { /* sin almacenamiento: solo esta pantalla */ }
  }, []);
  return [vista, setVista];
}

// `compacto`: versión chica para barras de herramientas densas (estado de cuenta).
export default function SelectorMoneda({ vista, onChange, className = '', compacto = false }) {
  return (
    <div className={`inline-flex rounded-md border overflow-hidden ${compacto ? 'text-xs' : 'text-sm'} print:hidden ${className}`} role="group" aria-label="Moneda del reporte">
      {[['BCV', 'Ver en BCV'], ['USD', 'Ver en USD']].map(([v, label]) => (
        <button
          key={v}
          type="button"
          onClick={() => onChange(v)}
          aria-pressed={vista === v}
          className={`${compacto ? 'px-2 py-1' : 'px-3 py-2'} whitespace-nowrap ${vista === v ? 'bg-primary-600 text-white' : 'bg-white text-slate-600 hover:bg-slate-50'}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
